export default __webpack_public_path__ + "static/media/java.09021cf3.svg";